<template>
  <section>
    <swiper
      :pagination="{
        dynamicBullets: true,
      }"
      :lazy="true"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: true,
      }"
      :navigation="true"
      :modules="modules"
      class="sellerBanner"
      :class="[pageName]"
      id="container"
    >
      <template v-if="pageName == 'showInHomePage'">
        <swiper-slide
          v-for="(item, index) in themeInfo?.info?.imageGallery.filter((el) => {
            return el.showIn == 'slider';
          })"
          :key="index"
        >
          <img :src="item.file" alt="" class="swiper-lazy" />
          <p class="slider_category">{{ item.category }}</p>
          <p class="slider_title">{{ item?.title }}</p>
        </swiper-slide>
      </template>

      <template v-if="pageName == 'showInMembersPage'">
        <template
          v-if="
            themeInfo?.info?.imageGallery.filter((el) => {
              return (el.showIn == 'banner') & (el.cat_id == 4);
            }).length > 0
          "
        >
          <swiper-slide
            v-for="(item, index) in themeInfo?.info?.imageGallery.filter(
              (el) => {
                return (el.showIn == 'banner') & (el.cat_id == 4);
              }
            )"
            :key="index"
          >
            <img :src="item.file" alt="" class="swiper-lazy" />
            <p class="slider_category">{{ item.category }}</p>
            <p class="slider_title">{{ item?.title }}</p>
          </swiper-slide>
        </template>
        <swiper-slide v-else>
          <img
            src="@/assets/img/banner_employer.png"
            class="swiper-lazy"
            alt=""
          />
        </swiper-slide>
      </template>

      <template v-if="pageName == 'showInProductsPage'">
        <template
          v-if="
            themeInfo?.info?.imageGallery.filter((el) => {
              return (el.showIn == 'banner') & (el.cat_id == 3);
            }).length > 0
          "
        >
          <swiper-slide
            v-for="(item, index) in themeInfo?.info?.imageGallery.filter(
              (el) => {
                return (el.showIn == 'banner') & (el.cat_id == 3);
              }
            )"
            :key="index"
          >
            <img :src="item.file" alt="" class="swiper-lazy" />
            <p class="slider_category">{{ item.category }}</p>
            <p class="slider_title">{{ item?.title }}</p>
          </swiper-slide>
        </template>
        <swiper-slide v-else>
          <img
            src="@/assets/img/banner_product.png"
            class="swiper-lazy"
            alt=""
          />
        </swiper-slide>
      </template>
    </swiper>
    <editBox
      :option="['edit']"
      :size="'large'"
      :item="pageName"
      :itemId="0"
      displayMode="horizontal_center"
    />
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/lazy";
import { Autoplay, Pagination, Navigation, Lazy } from "swiper";
import { mapGetters } from "vuex";
import editBox from "@/components/editBox/index.vue";
export default {
  name: "sellerBanner",
  props: ["pageName"],
  data() {
    return {
      playeAudio: false,
    };
  },
  watch: {
    playeAudio(newQuestion) {
      if (newQuestion === false) {
        console.log("pause");
        this.$refs.audioElm.pause();
      } else {
        this.$refs.audioElm.play();
        console.log("play");
      }
    },
  },
  methods: {},
  components: {
    Swiper,
    SwiperSlide,
    editBox,
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
    }),
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation, Lazy],
    };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/SellerBanner/SellerBanner.css);
</style>